import { gql } from "@apollo/client";
import { visualSelectorModelFragment } from "@src/pages/visualSelectorPage/VisualSelectorPage.gql";

export const SEARCH_PAGE_LIMIT = 10;

export const fulltextSearchQuery = gql`
    query FulltextSearchModels($query: String!, $filter: ModelFilter, $offset: Int!) {
        models(search: $query, filter: $filter, offset: $offset, limit: 10) {
            nodes {
                ...VisualSelectorModel
            }
            totalCount
        }
    }
    ${visualSelectorModelFragment}
`;
